import React from 'react';
import Image from 'next/image';

const EvilNoundleThumbnail = ({ tokenId, size }) => {
  const src = `${process.env.NEXT_PUBLIC_EVIL_NOUNDLES_THUMBNAIL_BASEURL}${tokenId}.png`;

  return (
    <div>
      <Image
        src={src}
        alt={`Ruggle #${tokenId}`}
        width={size}
        height={size}
        unoptimized
      />
      <div>
        <div className="p-1 text-center fw-bold">Ruggle #{tokenId}</div>
      </div>
    </div>
  );
};

EvilNoundleThumbnail.defaultProps = {
  size: 200,
};

export default EvilNoundleThumbnail;
